// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__profile--HS2L8 {
  position: absolute;
  right: 1rem;
  top: 1rem;
  z-index: 6;
}
.style__userName--ARmGv {
  color: #0c0d0d;
}
.style__userRole--vYZ5c {
  color: #7d8287;
}
.style__release--iSku6 {
  display: flex;
  flex-direction: column;
}
.style__userLogout--MGagx {
  margin-left: 5px;
  cursor: pointer;
  margin-right: 0.75em;
}
.style__userPicture--TJldt {
  border-radius: 50%;
  background-color: #95999d;
  height: 2.5em;
  width: 2.5em;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
  color: #0c0d0d;
}
.style__dropdownContent--Itosp {
  border-radius: 0.5em;
  display: none;
  position: absolute;
  background-color: #fff;
  min-width: 160px;
  box-shadow: 0 0.75rem 1rem -0.25rem rgba(12, 13, 13, 0.1), 0 0.25rem 6px -0.125rem rgba(12, 13, 13, 0.05);
  z-index: 2;
  right: 0;
  width: max-content;
}
.style__dropdownContent--Itosp:hover {
  display: flex;
  flex-direction: column;
}
.style__profileOpen--NHvN0 > div {
  display: flex;
  flex-direction: column;
}
.style__dropdownItem--QBxPb {
  display: flex;
  align-items: center;
  padding: 0.75em 1rem;
  color: #7d8287;
  gap: 0.75rem;
}
.style__dropdownItemBorder--Rbb6g {
  border-top: 1px solid #e3e8e5;
}
.style__dropdownItemLogout--zC41v {
  padding: 0.625em 1rem;
  cursor: pointer;
}
.style__dropdownItemVersion--cCKEu {
  padding: 0.625em 1rem;
}
`, "",{"version":3,"sources":["webpack://./../components/src/Profile/style.less","webpack://./../components/src/shadows.less"],"names":[],"mappings":"AAIA;EAEI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AAJJ;AADA;EASI,cAAA;AALJ;AAJA;EAaI,cAAA;AANJ;AAPA;EAiBI,aAAA;EACA,sBAAA;AAPJ;AAXA;EAsBI,gBAAA;EACA,eAAA;EACA,oBAAA;AARJ;AAhBA;EA4BI,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AATJ;AA3BA;EAwCI,oBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;ECzBF,yGAAA;ED2BE,UAAA;EACA,QAAA;EACA,kBAAA;AAVJ;AAtCA;EAoDI,aAAA;EACA,sBAAA;AAXJ;AA1CA;EA0DM,aAAA;EACA,sBAAA;AAbN;AA9CA;EAgEI,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,YAAA;AAfJ;AArDA;EAwEI,6BAAA;AAhBJ;AAxDA;EA4EI,qBAAA;EACA,eAAA;AAjBJ;AA5DA;EAiFI,qBAAA;AAlBJ","sourcesContent":["@import '../colors';\n@import '../shadows';\n@import '../spacing';\n\n:local {\n  .profile {\n    position: absolute;\n    right: @spacing-100;\n    top: @spacing-100;\n    z-index: 6;\n  }\n\n  .userName {\n    color: @color-asphalt-grey-005;\n  }\n\n  .userRole {\n    color: @color-asphalt-grey-050;\n  }\n\n  .release {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .userLogout {\n    margin-left: 5px;\n    cursor: pointer;\n    margin-right: 0.75em;\n  }\n\n  .userPicture {\n    border-radius: 50%;\n    background-color: @color-asphalt-grey-060;\n    height: 2.5em;\n    width: 2.5em;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 5px;\n    color: @color-asphalt-grey-005;\n  }\n\n  .dropdownContent {\n    border-radius: 0.5em;\n    display: none;\n    position: absolute;\n    background-color: @color-white;\n    min-width: 160px;\n    .sys-elevation-shadow-level3();\n    z-index: 2;\n    right: 0;\n    width: max-content;\n  }\n\n  .dropdownContent:hover {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .profileOpen {\n    > div {\n      display: flex;\n      flex-direction: column;\n    }\n  }\n\n  .dropdownItem {\n    display: flex;\n    align-items: center;\n    padding: 0.75em @spacing-100;\n    color: @color-asphalt-grey-050;\n    gap: @spacing-75;\n  }\n\n  .dropdownItemBorder {\n    border-top: 1px solid @color-pewter-grey-090;\n  }\n\n  .dropdownItemLogout {\n    padding: 0.625em @spacing-100;\n    cursor: pointer;\n  }\n\n  .dropdownItemVersion {\n    padding: 0.625em @spacing-100;\n  }\n}\n","@import 'colors';\n@import 'spacing';\n\n.sys-elevation-shadow-level0() {\n  box-shadow: 0 0 0 0 @color-asphalt-grey-005;\n}\n\n.sys-elevation-shadow-level1() {\n  box-shadow: 0 1px 3px 0 fade(@color-asphalt-grey-005, 10%),\n    0 1px @spacing-15 0 fade(@color-asphalt-grey-005, 6%);\n}\n\n.sys-elevation-shadow-level2() {\n  box-shadow: 0 @spacing-25 @spacing-50 -@spacing-15 fade(@color-asphalt-grey-005, 10%),\n    0 0 @spacing-25 -@spacing-15 fade(@color-asphalt-grey-005, 6%);\n}\n\n.sys-elevation-shadow-level2() {\n  box-shadow: 0 4px 8px -2px fade(@color-asphalt-grey-005, 10%),\n    0px 0px 4px -2px fade(@color-asphalt-grey-005, 6%);\n}\n\n.sys-elevation-shadow-level3() {\n  box-shadow: 0 @spacing-75 @spacing-100 -@spacing-25 fade(@color-asphalt-grey-005, 10%),\n    0 @spacing-25 6px -@spacing-15 fade(@color-asphalt-grey-005, 5%);\n}\n\n.sys-elevation-shadow-level4() {\n  box-shadow: 0 20px @spacing-150 -@spacing-25 fade(@color-asphalt-grey-005, 10%),\n    0 @spacing-50 @spacing-50 -@spacing-25 fade(@color-asphalt-grey-005, 4%);\n}\n\n.sys-elevation-shadow-level5() {\n  box-shadow: 0 @spacing-150 @spacing-300 -@spacing-75 fade(@color-asphalt-grey-005, 15%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profile": `style__profile--HS2L8`,
	"userName": `style__userName--ARmGv`,
	"userRole": `style__userRole--vYZ5c`,
	"release": `style__release--iSku6`,
	"userLogout": `style__userLogout--MGagx`,
	"userPicture": `style__userPicture--TJldt`,
	"dropdownContent": `style__dropdownContent--Itosp`,
	"profileOpen": `style__profileOpen--NHvN0`,
	"dropdownItem": `style__dropdownItem--QBxPb`,
	"dropdownItemBorder": `style__dropdownItemBorder--Rbb6g`,
	"dropdownItemLogout": `style__dropdownItemLogout--zC41v`,
	"dropdownItemVersion": `style__dropdownItemVersion--cCKEu`
};
export default ___CSS_LOADER_EXPORT___;
